import { CartItem } from "./models/cart.model";

/**
 * Dollar floor for Rubbl Managed Services on rentals longer than one day.
 * Matches `BillingConstants.PremiumServicesMinimum`. The percentage is not a
 * constant: checkout stores it on the cart item's PremiumServices charge
 * (`Amount` is the fraction, e.g. 0.14) from account billing config, which
 * falls back to platform `RubblManagedServicesPercentage`.
 */
export const RUBBL_MANAGED_SERVICES_MINIMUM = 149;

interface ServicesCharge {
  chargeCategory?: string;
  amount?: number;
  minimumAmount?: number;
}

/**
 * Customer-facing tooltip. The percent comes from the charge checkout will
 * bill for this cart item, so an account override cannot drift from the copy.
 */
export function rubblManagedServicesInfo(item: Pick<CartItem, "charges"> | { charges?: ServicesCharge[] } | null | undefined): string {
  const charge = item?.charges?.find(c => c?.chargeCategory === "PremiumServices");
  const rateText = formatRate(charge?.amount);
  const minimum = charge?.minimumAmount != null && charge.minimumAmount > 0 ? charge.minimumAmount : RUBBL_MANAGED_SERVICES_MINIMUM;
  const fee = rateText ? `A fee of ${rateText} of your rental rate.` : "A fee based on your rental rate.";
  return `${fee} Includes damage and liability coverage, transportation logistics, and repair coordination. Minimum ${formatDollars(minimum)}.`;
}

function formatRate(amount: number | null | undefined): string | null {
  const rate = Number(amount);
  // PercentOfTotal stores a fraction. 1 or more is a dollar amount, not the rate.
  if (!Number.isFinite(rate) || rate <= 0 || rate >= 1) {
    return null;
  }

  const percent = Math.round(rate * 1000) / 10;
  const text = Number.isInteger(percent) ? percent.toFixed(0) : percent.toFixed(1);
  return `${text}%`;
}

function formatDollars(amount: number): string {
  const rounded = Math.round(amount * 100) / 100;
  return Number.isInteger(rounded) ? `$${rounded}` : `$${rounded.toFixed(2)}`;
}
